import { t } from "i18next";
import { GenericLink } from "../../../Shared/components/GenericLink";
import { LoginForm } from "./LoginForm";
import { useLocation } from "react-router-dom";

export const Login = () => {
  const location = useLocation();
  const loginInput = location.state?.loginInput;

  return (
      <div className="container mx-auto">
        <section className="flex flex-col md:flex-row items-center py-12 my-12">
          <div className="hidden md:block w-full md:max-w-md lg:max-w-full md:mx-auto md:w-1/2 xl:w-2/3 px-6 lg:px-16 xl:px-12">
            <div className="mt-6 w-full py-5 flex items-center justify-center">
              <div className="pt-5 w-full">
                <div className="py-3 text-2xl font-semibold">
                  <p className="text-3xl font-bold leading-tight">
                    {t('welcome_back')}
                  </p>
                </div>
                <div className="py-5">
                  <p>{t('welcome_back_message')}</p>
                </div>
                <div className="py-5">
                  <div className="">
                      {t('signup_prompt')}
                      <span className="px-3">
                        <GenericLink
                          to="/auth/register"
                          label={t('signup_prompt_2')}
                          className="text-sky-600 font-medium"
                        />
                      </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full md:max-w-md lg:max-w-full md:mx-auto md:w-1/2 xl:w-1/2 px-6 lg:px-16 xl:px-12">
            <LoginForm loginInput={loginInput} />
          </div>
        </section>
      </div>
  );
};
